import React from 'react';
import styled from 'styled-components';
import { IAction } from '../../../ui/dialog/Dialog';
import SectionTitle from '../sectionTitle/SectionTitle';
import LegalText from '../legalText/LegalText';
import { ActionDialog } from '../ActionDialog/ActionDialog';

const SSectionTitle2 = styled(SectionTitle)`
  @media only screen and (min-width: 800px) {
    font-size: 23px;
  }
`;

const SLegalText2 = styled(LegalText)(
  () => `
  font-size: 10px;
  @media only screen and (min-width: 800px) {
    font-size: 12px;
  }
`
);
interface IOutOfRangeIncomeDialogProps {
  actionList: IAction[];
  onCloseAction: VoidFunction;
}

// tslint:disable-next-line:variable-name
const OutOfRangeIncomeDialog: React.FC<IOutOfRangeIncomeDialogProps> = ({ actionList, onCloseAction }) => {
  return (
    <ActionDialog onCloseAction={onCloseAction} actionList={actionList}>
      <SSectionTitle2 data-at="out-of-range-income-dialog-text">Please ensure that you entered your FULL MONTHLY net income (including all sources of income*).</SSectionTitle2>
      <br />
      <SLegalText2 dataAt="out-of-range-income-disclaimer">
        * This is the amount you take home after taxes or the amount you can reasonably expect to have access to each month. Income includes current or reasonably expected wages, salary, retirement
        income, public assistance, alimony, child support, interest or dividends, and separate maintenance income. If you are under 21, include only your own income.
      </SLegalText2>
    </ActionDialog>
  );
};

export default OutOfRangeIncomeDialog;
